<template>
    <div class="demo-code" v-if="request">
        <div class="title">
            <h4>{{$t('demo.2nd title')}}</h4>
            <div class="desc">{{$t('demo.code sent', {phone: phoneMask})}}</div>
        </div>
        <form @submit.prevent="confirm" class="form">
            <div class="row">
                <div class="col">
                    <div class="field">
                        <div class="label center">{{$t('demo.confirmation code')}}</div>
                        <input class="control center"
                               type="text"
                               v-model="confirmationCode"
                               @input="onCodeChange"
                               maxlength="4" />
                        <div class="control-msg" v-if="error"><span class="error">{{$t('demo.confirmation code error')}}</span></div>
                    </div>
                </div>
            </div>
            <div class="row controls">
                <div class="col layout-row layout-center layout-wrap">
                    <button class="button cancel" type="reset" @click="cancelCodeConfirmation">
                        <i class="icon-arrow_back"></i>
                        <span>{{$t('demo.cancel')}}</span>
                    </button>
                    <button class="button" type="submit" :disabled="loading">{{$t('demo.continue')}}<loader v-if="loading" /></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import demoService from "../../services/demo.service";

export default {
    name: "demo-code-form",
    props: {
        request: Object
    },
    data() {
        return {
            error: false,
            loading: false,
            confirmationCode: null
        };
    },
    computed: {
        phoneMask() {
            if (!this.request || !this.request.phone) return "***";
            return "***" + this.request.phone.substr(this.request.phone.length - 4);
        }
    },

    mounted() {},
    beforeDestroy() {},
    methods: {
        cancelCodeConfirmation() {
            this.$emit("cancel");
        },
        async onCodeChange() {
            if (!this.confirmationCode || this.confirmationCode.length != 4) return

            await this.confirm();
        },
        async confirm() {
            if (this.loading) return;
            
            try {
                this.loading = true;
                this.error = false;
                const resp = await demoService.confirm({
                    phone: this.request.phone,
                    code: this.confirmationCode
                });
               
                this.$emit("complete", resp);
            } catch (e) {
                console.error("Failed to send demo request", e);
                this.confirmationCode = null;
                this.error = true;
            }
            finally{
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.title {
    font-size: 2.5rem;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: $spacer * 4;

    h4 {
        margin-top: 0;
        margin-bottom: $spacer;
    }

    .desc {
        font-size: 2rem;
        margin-bottom: $spacer;
    }
}

.controls {
    margin-top: $spacer * 2;
}

.control {
    font-size: 2rem;
    width: 200px;
}

.button {
    margin: $spacer/2 $spacer;
    width: 200px;

    &.cancel {
        background: $grey;
        color: $black;

        &:hover {
            background: darken($grey, 10);
        }
    }
}

.control-msg {
    text-align: center;
    margin-top: $spacer;

    span {
        display: inline-block;
        background: lighten($red, 40);
        color: $red;
        padding: $spacer;
    }
}

@media (max-width: ($mobile)-1) {

    .title {
        margin-bottom: 0;
    }

    .controls {
        margin-top: 0;

        .col {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

}
</style>
